import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GetBasicReservationInformationStoreService } from '@lib/services';
import { MyBookingTabShow } from '@common/helpers/enums/servicing.enum';
import { ServicingCommonStoreService } from '@common/services';
import { SERVICING_ROUTES } from '@conf/routes.config';

@Component({
  selector: 'asw-duty-free-preorder-guidance-sub-header',
  templateUrl: './duty-free-preorder-guidance-sub-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DutyFreePreorderGuidanceSubHeaderComponent {
  /** 戻り先URL_予約詳細画面(S01-P030) */
  backUrl = SERVICING_ROUTES.myBooking;

  constructor(
    private _servicingCommonStoreService: ServicingCommonStoreService,
    private _getBasicReservationInformationStoreService: GetBasicReservationInformationStoreService
  ) {}

  goBack(): void {
    /** 予約詳細表示タブ=”service”(予約詳細(サービス))を保持 */
    this._servicingCommonStoreService.updateServicingCommon({
      tabShow: MyBookingTabShow.MyBookingTabShowEnum.Service,
    });

    /** 予約基本情報取得レスポンスをクリアする
     * （PNR情報と免税品パラメータ暗号化レスポンスはそれぞれのdestoryでクリアされるため、これだけ明示的にクリア処理をする) */
    this._getBasicReservationInformationStoreService.resetGetBasicReservationInformation();
  }
}
